import { createFileRoute, Outlet } from '@tanstack/react-router';

import { backendApiUsersFindOneOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/management/users/$userId')({
  component: Outlet,
  beforeLoad: async ({ params: { userId }, context: { queryClient } }) => {
    const userData = await queryClient.ensureQueryData(
      backendApiUsersFindOneOptions({
        path: { userId },
      }),
    );

    return {
      breadcrumb: userData?.email,
    };
  },
});
